import { L10n, loadCldr, setCulture } from '@syncfusion/ej2-base'
import csNumbers from 'cldr-data/main/cs/numbers.json'
import csGregorian from 'cldr-data/main/cs/ca-gregorian.json'
import numberingSystems from 'cldr-data/supplemental/numberingSystems.json'
import csTimeZoneNames from 'cldr-data/main/cs/timeZoneNames.json'
import weekData from 'cldr-data/supplemental/weekData.json'

export function ejsDatetimepickerInit() {
  console.log('ejsDatetimepickerInit')

  setCulture('cs')

  // weekData loads the culture-based first day of week
  loadCldr(csNumbers, csGregorian, numberingSystems, csTimeZoneNames, weekData)

  L10n.load({
    cs: {
      datepicker: {
        day: 'd',
        month: 'm',
        year: 'r',
      },
      timepicker: {
        hour: 'hh',
        minute: 'mm',
      },
      datetimepicker: {
        placeholder: 'Vyberte datum a čas',
        today: 'dnes',
      },
      daterangepicker: {
        applyText: 'Vybrat',
        // placeholder:
        startLabel: 'Začátek',
        endLabel: 'Konec',
        cancelText: 'Zrušit',
        selectedDays: 'Počet vybraných dní',
        days: 'd',
        customRange: 'Vlastní',
      },
    },
  })
}
